module.exports = __webpack_public_path__ + "img/h_spades.99454ae5.png";